var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-bar w-full bg-white flex flex-space-evenly"},[_c('WFBuildingLogo',{staticClass:"grow-0 shrink-1 basis-1/4"}),_c('div',{staticClass:"flex-spacer"}),_c('div',{staticClass:"header-dt"},[_c('WFClock'),_c('WFDate',{attrs:{"format":"ddd. DD. MMM"}})],1),_c('div',{staticClass:"flex-spacer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }